<template>
  <div class="traceability-main-view">
    <modal
      ref="traceabilityStatusGuide"
      :icon-enabled="false"
      :close-button-enabled="true"
      title="Entenda o que é cada Status da Rastreabilidade"
      template="question"
      first-button-text="Voltar"
      first-button-style="btn-quarternary"
      :hide-second-button="true"
      :hide-first-button="true"
      ref-name="traceabilityStatusGuide"
      @first-cta="closeStatusGuideModal()"
      @close="closeStatusGuideModal()"
    >
      <div class="status-glossary">
        <div
          v-for="(state, index) in statusUpdated"
          :key="index"
          class="status-glossary__row"
        >
          <div
            v-if="state.glossary"
            class="status"
          >
            <span
              class="bullet"
              :class="state.symbolColor"
            >
              •
            </span>
            <p>{{ state.translated }}</p>
          </div>
          <div class="glossary">
            {{ state.glossary }}
          </div>
        </div>
      </div>
    </modal>

    <traceability-subheader title="Busca por:">
      <combo-box
        v-if="false"
        id="sort-traceability"
        title="ordernar por"
        :options="options"
        option-label="label"
        placeholder="Selecione"
        :field.sync="sortBy"
      />
    </traceability-subheader>

    <search-batch />

    <div class="wrapper-grid">
      <traceability-table-header />
      <exams-filters
        @submit="handleSubmitExamsFilter"
        :enabled-status="examsFilterEnabledStatus"
      />
      <exams-orders-data-table :exams="exams" />
    </div>
  </div>
</template>

<script>
import CountIndicator from '@/components/Dashboard/Widgets/CountIndicator'
import Card from '@/components/Dashboard/Card'
import comboBox from '../common/ComboBox'
import TraceabilityDataTable from './TraceabilityDataTable'
import TraceabilitySubHeader from './TraceabilitySubHeader'
import FastDownload from '@/components/Results/FastDownload/FastDownload'
import Spinner from '../common/Spinner'
import { mapActions } from 'vuex'
import {
  DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS,
  TRACEABILITY_SEARCH_DATE,
  TRACEABILITY_SEARCH_BATCH,
  TraceabilityStatus,
} from '@/enums'
import Moment from 'moment'
import strings from '@/strings'
import TraceabilitySearchBatch from './TraceabilitySearchBatch.vue'
import ExamsOrdersDataTable from '../SamplesTraceability/ExamsOrdersDataTable.vue'
import examService from '@/api/exam'
import ExamsFilter from '../SamplesTraceability/ExamsFilter.vue'
import TraceabilityTableHeader from './TraceabilityTableHeader.vue'

export default {
  name: 'TraceabilityMainView',
  components: {
    'count-indicator': CountIndicator,
    card: Card,
    'combo-box': comboBox,
    'traceability-data-table': TraceabilityDataTable,
    'traceability-subheader': TraceabilitySubHeader,
    spinner: Spinner,
    'fast-download': FastDownload,
    'search-batch': TraceabilitySearchBatch,
    'exams-orders-data-table': ExamsOrdersDataTable,
    'exams-filters': ExamsFilter,
    'traceability-table-header': TraceabilityTableHeader,
  },
  data() {
    return {
      sortBy: null,
      interval: null,
      minutes: 0,
      status: strings.traceabilityStatus,
      updateTime: new Date(),
      options: [
        { value: 'motivo', label: 'Motivo' },
        { value: 'os_alvaro', label: 'OS Álvaro' },
        { value: 'date', label: 'Prazo da Resolução' },
        { value: 'status', label: 'Status' },
        { value: 'os_lis', label: 'OS Lis' },
        { value: 'batch', label: 'Lote' },
      ],
      exams: [],
    }
  },
  computed: {
    examsFilterEnabledStatus() {
      if (this.searchIsBatch()) {
        return [
          TraceabilityStatus.Triage,
          TraceabilityStatus.PendingAnswered,
          TraceabilityStatus.Recalled,
          TraceabilityStatus.InRelease,
          TraceabilityStatus.PendingCreated,
          TraceabilityStatus.Canceled,
          TraceabilityStatus.InTransitBetweenNTOs,
        ]
      }

      return [
        TraceabilityStatus.Triage,
        TraceabilityStatus.InExecution,
        TraceabilityStatus.PendingAnswered,
        TraceabilityStatus.Recalled,
        TraceabilityStatus.InRelease,
        TraceabilityStatus.PendingCreated,
        TraceabilityStatus.ReportReleased,
        TraceabilityStatus.Canceled,
        TraceabilityStatus.InTransitBetweenNTOs,
      ]
    },
    statusUpdated() {
      delete this.status['LAUDO_LIBERADO']
      return this.status
    },
    timeAgo() {
      if (this.minutes === 0) {
        return { phrase: 'realizada', time: 'agora' }
      } else {
        return { phrase: 'realizada há', time: this.minutes + ' min' }
      }
    },
  },
  watch: {
    $route() {
      this.getInitialFilters()
    },
  },
  async mounted() {
    console.log('this.$route.query.typeOfSearch', this.$route.query.typeOfSearch)
    const { data } = await examService.getExams()

    this.exams = data
  },
  created() {
    this.getInitialFilters()
    this.updateTimeAgo()
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    ...mapActions(['getTraceabilityOrders', 'selectTraceabilityParams']),
    updateTimeAgo() {
      this.interval = setInterval(
        function () {
          this.calculateTimeAgo()
        }.bind(this),
        DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS
      )
    },
    async handleSubmitExamsFilter() {},
    async fetchExamsByNTO(nto) {
      try {
        const response = await examService.getExams({
          destinationId: nto.id,
        })

        return response?.data ?? []
      } catch (error) {
        console.error('Error fetching exams by NTO', error)
      }

      return []
    },
    openStatusGuideModal() {
      this.$refs.traceabilityStatusGuide.open()
    },
    closeStatusGuideModal() {
      this.$refs.traceabilityStatusGuide.close()
    },
    calculateTimeAgo() {
      let now = new Date()
      let milliseconds = Math.abs(this.updateTime.getTime() - now.getTime())
      this.minutes = Moment(milliseconds).minutes()
    },
    getFilterDefault() {
      let today = Moment(new Date()).format('DD/MM/YYYY')
      this.$router.push({
        path: this.$route.path,
        query: {
          startDate: today,
          endDate: today,
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
        },
      })
    },
    getInitialFilters() {
      if (this.$route.query.typeOfSearch) {
        this.selectTraceabilityParams(this.$router.history.current.query)
        this.getTraceabilityOrders()
      } else {
        this.getFilterDefault()
      }
    },
    searchIsBatch() {
      return this.$route.query.typeOfSearch === TRACEABILITY_SEARCH_BATCH
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../static/stylesheets/variables';

.traceability-main-view {
  height: $contentContainerHeight;
  padding-top: 0 !important;
  display: flex;
  flex-direction: column;
  margin: auto;
  width: 85%;

  .exams-filter {
    padding: 1rem;
  }

  .loader-table {
    margin-top: 20%;
    margin-left: 57%;
  }

  .wrapper-grid {
    background: #fff;
    border-radius: 8px;
  }

  .status-modal {
    padding: 10px;
    cursor: pointer;

    &:hover {
      color: #000;

      .header-title-info-icon {
        color: #7a7a7a;
      }
    }

    .md-icon {
      width: 20px;
      height: 20px;
    }
  }

  .search-title {
    display: flex;

    div {
      display: flex;
    }

    .md-icon {
      cursor: pointer;
      margin-right: 0.7em;
    }
  }

  .subheader__content__right-side {
    display: flex;

    .subheader-alternative-actions-container {
      position: inherit;
    }

    p {
      font-family: 'Exo 2', sans-serif !important;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      color: #7a7a7a;
      margin: auto;
    }
  }

  &__left-side {
    width: 20%;
    font-family: 'Exo 2', sans-serif !important;

    .dynamic-card,
    .dynamic-card h3,
    .dynamic-card h2,
    .dynamic-card .orange {
      font-family: 'Exo 2', sans-serif !important;
    }

    .md-card {
      margin-top: 4em;
      height: 120px;
      background: url('/static/images/icon-tubes.svg') no-repeat scroll 90% 18px #fff;
      font-family: 'Exo 2', sans-serif !important;
    }

    .results-fast-download {
      margin-top: 2em;
      font-family: 'Exo 2', sans-serif !important;

      .results-main-filter__title {
        font-family: 'Exo 2', sans-serif !important;
        font-style: normal;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 1px;
        color: #7a7a7a;
        margin-bottom: 1em;
        margin-left: 0;
      }
    }

    .loading-statistic-card__card-info,
    .result-card-download__card-info {
      margin: 0 !important;
    }
  }

  &__middle-side {
    margin-left: 2em;
    width: 78%;
    margin-top: 5em;

    h2 {
      font-size: 22px;
      font-weight: 400;
      letter-spacing: -0.3px;
      text-align: left;
      color: #7a7a7a;
      line-height: 1.09;
      font-family: 'Exo 2', sans-serif !important;
    }

    .btn-small {
      letter-spacing: 1px;
    }
  }

  .traceability-main-view__filter {
    width: 100%;
  }

  .traceability-main-view__grid {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
}

#traceabilityStatusGuide .md-dialog {
  width: 90%;
  max-width: 920px;

  .standard-modal__title {
    font-family: 'Exo 2', sans-serif !important;
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 26px;
    color: #7f1a54;
    margin-bottom: 0.7em;
  }

  .standard-modal__container-cta {
    padding-top: 1em;
  }

  .status-glossary {
    background: #eaeaea;
    padding: 19px 23px 6px;
    border-radius: 6px;

    &__row {
      flex-direction: row;
      display: flex;
      margin-bottom: 5px;
      font-family: 'Exo 2', sans-serif !important;

      .status {
        display: flex;
        align-items: center;
        flex: 1;

        p {
          flex: 7;
          font-family: 'Exo 2', sans-serif !important;
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 26px;
          color: #4a4a4a;
        }

        span {
          flex: 0.8;
          font-size: 25px;
          font-weight: bold;
        }
      }

      .glossary {
        flex: 2;
        margin: auto;
        font-family: 'Exo 2', sans-serif !important;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 26px;
        color: #4a4a4a;
      }
    }
  }
}
</style>
